import { Container, Row, Col, Card, Badge } from "react-bootstrap";

import {
  RiPhoneLine,
  RiMailLine,
  RiBuildingLine,
  RiTruckLine,
  RiMapPinLine,
  RiFileListLine,
  RiTimeLine
} from "react-icons/ri";

import { RxDotsVertical } from "react-icons/rx";
import { LuCopy } from "react-icons/lu";
import { useState } from "react";
import moment from "moment";

// import "./driverDetails.css";

export default function DriverDetails({ driver }) {
  const [isTextCopied, setIsTextCopied] = useState(null);

  // ==================COPY GATE CODE=================
  const CopyGateCode = (gateCode, id) => {
    navigator.clipboard.writeText(gateCode);
    setIsTextCopied(id);
    setTimeout(() => {
      setIsTextCopied(null);
    }, 1000);
  };

  const getExpiration = () => {
    const endDate =
      driver?.reservation?.[driver?.reservation?.length - 1]?.reservationEndDate;
    const timezone = driver?.location?.timezone || "UTC";

    const days = moment(endDate)
      .tz(timezone)
      .diff(moment().tz(timezone), "days");

    return {
      text: days < 0 ? "Expired" : `${days} Days`,
      expired: days < 0,
    };
  };



  return (
    <div className="container p-3 bg-white rounded-3 border">

      {/* HEADER */}
      {(driver?._id) ? (<>
        <Card className="dd-card mb-2 border-0">

          <Card.Body className="d-flex justify-content-between align-items-center p-0">

            <div className="d-flex gap-3 align-items-center">
              <img
                src={driver?.driver?.profile || "/assets/images/placeholder.png"}
                alt=""
                className="dd-avatar"
              />

              <div>
                <h5 className="mb-1">{driver?.driver?.name || ""}</h5>

                <div className="dd-contact">
                  <span><RiPhoneLine /> {driver?.driver?.phone || ""}</span>
                  <span><RiMailLine /> {driver?.driver?.email || ""}</span>
                </div>

                {/* <div className="dd-company">
                <RiBuildingLine /> Fast Freight LLC
              </div> */}
              </div>
            </div>

            <RxDotsVertical className="dd-menu" />
          </Card.Body>
        </Card>

        <div className="text-muted small ">Booking ID :<Badge bg="transparent" className="border text-dark">{driver?._id}</Badge></div>

        {/* STATUS */}
        <div className="status-flex mb-2">

          <div className="status-item">
            <p className="label">STATUS</p>
            <div className={driver?.status === "Active" ? "badge-active" : "badge-inactive"}>
              <span className={driver?.status === "Active" ? "dot green" : "dot red"}></span> {driver?.status || "Active"}
            </div>
          </div>

          <div className="divider"></div>

          <div className="status-item">
            <p className="label">LAST ACTIVITY</p>
            <div className="value">
              <RiTimeLine /> -
            </div>
            <small></small>
          </div>

          <div className="divider"></div>

          <div className="status-item">
            <p className="label">ASSIGNED LOCATIONS</p>
            <div className="value">
              <RiMapPinLine /> {driver?.location?.yard || ""}
            </div>
            <small className="value">{driver?.location?.address || ""}</small>
          </div>

        </div>

        {/* INFO */}
        <Card className="dd-card mb-2">
          <Card.Body>
            <Row className="align-items-start">

              <Col className="d-flex align-items-center gap-2">
                <RiTruckLine className="info-icon" />
                <div>
                  <p className="label">TRUCK</p>
                  <strong>{driver?.vehicle?.truck || ""}</strong>
                </div>
              </Col>

              <Col xs="auto"><div className="divider"></div></Col>

              <Col className="d-flex align-items-center gap-2">
                <RiFileListLine className="info-icon" />
                <div>
                  <p className="label">PLATE</p>
                  <strong>{driver?.vehicle?.plate || ""}</strong>
                </div>
              </Col>

              <Col xs="auto"><div className="divider"></div></Col>

              <Col className="d-flex align-items-center gap-2">
                <RiMapPinLine className="info-icon" />
                <div>
                  <p className="label">YARD</p>
                  <strong>{driver?.location?.yard || ""}</strong>
                </div>
              </Col>

            </Row>
          </Card.Body>
        </Card>

        <Card className="dd-card">
          <Card.Body className="p-0">

            <div className="res-flex">

              {/* CURRENT RESERVATION */}
              <div className="res-item res-main">
                <p className="label">CURRENT RESERVATION</p>
                {driver?.reservation?.map((reservation, i) => (
                  <div className="fw-semibold date text-dark border-bottom rounded-0 strong py-2 p-0" key={i}>
                    {moment(reservation?.reservationStartDate).tz(driver?.location?.timezone || moment.tz.guess()).format("MMM DD, h:mm A")} – {moment(reservation?.reservationEndDate).tz(driver?.location?.timezone || moment.tz.guess()).format("MMM DD, h:mm A")}
                  </div>
                ))}
              </div>

              <div className="divider"></div>

              {/* EXPIRATION */}
              <div className="res-item res-small">
                <p className="label">EXPIRATION</p>

                <strong className={getExpiration().expired ? "text-danger" : ""}>
                  {getExpiration().text}
                </strong>

              </div>


              {/* <div className="divider"></div> */}

              {/* GATE CODE */}
              <div className="res-gate">
                <p>GATE CODE</p>
                <div className="gate-row">
                  <h3>{driver?.gateCode || ""}</h3>
                  {driver?.gateCode && (
                    <span className="position-relative d-inline-block">
                      <LuCopy
                        className="cursor-pointer ms-1 mb-2"
                        onClick={() => CopyGateCode(driver?.gateCode, driver?._id)}
                      />
                      {isTextCopied === driver?._id && (
                        <span
                          className="position-absolute bottom-100 start-50 translate-middle-x mb-1 px-2 py-1 rounded bg-dark text-white"
                          style={{ fontSize: "0.75rem", whiteSpace: "nowrap", zIndex: 10 }}
                        >
                          Copied!
                        </span>
                      )}
                    </span>
                  )}
                </div>
              </div>
            </div>

          </Card.Body>
        </Card>
      </>) : (
        <div className='text-center align-content-center' style={{ height: '350px' }}>
          <p>No Record Found.</p>
        </div>
      )}

    </div>
  );
}